import { Market } from "@features/market/config/i18n-config";
import type { Auth } from "firebase/auth";

export default async function initAuthClient(market: Market): Promise<Auth> {
  const [{ default: firebaseApp }, firebaseAuth] = await Promise.all([
    import("@/config/firebaseApp"),
    import("firebase/auth"),
  ]);
  const {
    initializeAuth,
    getAuth,
    indexedDBLocalPersistence,
    browserLocalPersistence,
  } = firebaseAuth;

  let client: Auth;
  try {
    client = initializeAuth(firebaseApp, {
      persistence: [indexedDBLocalPersistence, browserLocalPersistence],
    });
  } catch {
    client = getAuth(firebaseApp);
  }

  client.languageCode = market.languageCode;

  return client;
}
